import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function DocumentNameReducer(
	state = initialState.documentName,
	action
) {
	switch (action.type) {
		case types.UPDATE_DOCUMENT_NAME: {
			if (action.response.data) {
				return action.response.data || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		}
		case types.DELETE_DOCUMENT_ITEM: {
			if (action.response.data) {
				return action.response.data || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		}
		case types.CLEAN_DOCUMENT_ITEM: {
			return [];
		}
		default:
			return state;
	}
}
